import { Configuration, PublicClientApplication } from '@azure/msal-browser';

const env = process.env.REACT_APP_BUILD;

const appClientIdNonProd = 'c57f664a-005b-4f4e-9c85-d1b7dcf81b09'; // enablement-dashboard-service-nonprod
const appClientIdProd = 'c3ccb5fe-51db-4266-a96b-a3521f234405'; // enablement-dashboard-service-prod

const configuration: Configuration = {
  auth: {
    clientId: env === 'prd' ? appClientIdProd : appClientIdNonProd,
    authority: 'https://login.microsoftonline.com/d1ee1acd-bc7a-4bc4-a787-938c49a83906'
  }
};

export const pca = new PublicClientApplication(configuration);

export const authRequest = () => {
  const activeAccount = pca.getActiveAccount();
  const accounts = pca.getAllAccounts();

  return {
    scopes: env === 'prd' ? [`api://${appClientIdProd}/read`] : [`api://${appClientIdNonProd}/read`],
    account: activeAccount || accounts[0],
    redirectUri: `${window.location.origin}`
  };
};

export const acquireAccessToken = async () => {
  const request = authRequest();
  const authResult = await pca.acquireTokenSilent(request);
  return authResult.accessToken;
};
